module.exports = {
  assign: require('./assign'),
  assoc: require('./assoc'),
  binary: require('./binary'),
  compose: require('./compose'),
  composeK: require('./composeK'),
  composeP: require('./composeP'),
  composeS: require('./composeS'),
  curry: require('./curry'),
  defaultProps: require('./defaultProps'),
  defaultTo: require('./defaultTo'),
  dissoc: require('./dissoc'),
  fromPairs: require('./fromPairs'),
  getPathOr: require('./getPathOr'),
  liftA2: require('./liftA2'),
  liftA3: require('./liftA3'),
  liftN: require('./liftN'),
  getPropOr: require('./getPropOr'),
  mapProps: require('./mapProps'),
  mapReduce: require('./mapReduce'),
  mconcat: require('./mconcat'),
  mconcatMap: require('./mconcatMap'),
  mreduce: require('./mreduce'),
  mreduceMap: require('./mreduceMap'),
  nAry: require('./nAry'),
  objOf: require('./objOf'),
  omit: require('./omit'),
  once: require('./once'),
  partial: require('./partial'),
  pick: require('./pick'),
  pipe: require('./pipe'),
  pipeK: require('./pipeK'),
  pipeP: require('./pipeP'),
  pipeS: require('./pipeS'),
  propOr: require('./propOr'),
  propPathOr: require('./propPathOr'),
  setPath: require('./setPath'),
  setProp: require('./setProp'),
  tap: require('./tap'),
  unary: require('./unary'),
  unit: require('./unit'),
  unsetPath: require('./unsetPath'),
  unsetProp: require('./unsetProp')
}
